export class JustificativaManifesto {
    Texto: String = "";
}
